export default [
  "skip-subscription",
  "skip-wizard",
  "skip-manager",
  "skip-ref",
  "skip-subscription",
  "create-ref-link",

  // service-meals
  "get-all-meals",
  "get-all-categories",
  "get-all-ingredients",
  "get-template-meals",
  "apply-templates",
  "remove-templates",
  "get-all-templates",
  "create-meals",
  "create-categories",
  "create-ingredients",
  "update-meals",
  "update-categories",
  "update-ingredients",
  "delete-meals",
  "delete-categories",
  "delete-ingredients",

  // service-telegram-authorization
  "get-managed-users",
  "get-managed-users-balance",
  "continue-managed-users-subscription",
  "get-managed-users-transactions",
  "update-managed-users-meta",
  "switch-user",
  "switch-previous-user",
  "switch-next-user",

  // service-measurements
  "get-all-measurements",
  "update-all-measurements"
] as const;
